import React, { useState } from 'react'
import { Trash2, User } from 'react-feather'
import ConfirmationDialog from 'src/components/common/feedback-and-dialog/ConfirmationDialog'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import PhoneNumberInputField from 'src/components/common/form-elements/PhoneNumberInputField'
import { useLocale } from 'src/lib/hooks/useLocal'
import {
  AdditionalPocContactValueType,
  AdditionalPocContactErrorsType,
  AdditionalPocContactKeyType
} from 'src/lib/types/settings'
import 'react-phone-input-2/lib/style.css'

interface AdditionalPocContact {
  values: AdditionalPocContactValueType
  errors: AdditionalPocContactErrorsType
  isEditable: boolean
  index: number
  handleFieldChange: (index: number, fieldName: AdditionalPocContactKeyType, value: string) => void
  onDeleteAdditionalPOC: (index: number) => void
}
const AdditionalPocContact: React.FC<AdditionalPocContact> = ({
  errors,
  values,
  isEditable,
  handleFieldChange,
  index,
  onDeleteAdditionalPOC
}) => {
  const { t } = useLocale()
  const inputStyle = { style: { fontSize: '14px' } }
  const contactLabels = ['I', 'II', 'III']
  const contactLabel = `Contact ${contactLabels[index]}`
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState<boolean>(false)

  return (
    <>
      <div className='border-t-1 bg-white overflow-hidden'>
        <div className='bg-gray-lightest flex justify-between px-4 py-3 items-center '>
          <div className=' flex gap-2 items-center bg-white px-3 py-2 rounded-3xl font-medium border-1 border-gray-light'>
            <User size={16} />
            <span>{contactLabel}</span>
          </div>
          {isEditable && (
            <div
              className='p-3   rounded-lg cursor-pointer border-1 border-gray-light'
              onClick={() => setIsDeleteConfirmOpen(!isDeleteConfirmOpen)}
            >
              <Trash2 size={16} />
            </div>
          )}
        </div>
        <div className='grid grid-cols-2 w-full rounded-lg  gap-5 p-4 bg-white'>
          <InputTextField
            label={t('poc_name')}
            inputProps={inputStyle}
            textFieldId={`additional_poc_name_${index}`}
            errorStatus={errors?.name?.status}
            errorMessage={errors?.name?.message}
            customErrorMessage='Please enter at least 3 character in your name'
            handleChange={(e: any) => handleFieldChange(index, 'name', e.target.value)}
            inputType='text'
            inputValue={values?.name}
            isDisabled={!Boolean(isEditable)}
            isRequired={true}
            minCharacterLimit={3}
            toolTipRequired={false}
          />
          <InputTextField
            label={t('Designation')}
            inputProps={inputStyle}
            textFieldId={t('poc_designation')}
            handleChange={(e: any) => handleFieldChange(index, 'designation', e.target.value)}
            inputType='text'
            errorStatus={errors?.designation?.status}
            errorMessage={errors?.designation?.message}
            inputValue={values?.designation}
            isDisabled={!Boolean(isEditable)}
          />
          <InputTextField
            label={t('poc_email_id')}
            inputProps={inputStyle}
            textFieldId={`additional_poc_email_${index}`}
            errorStatus={errors?.email?.status}
            errorMessage={errors?.email?.message}
            handleChange={(e: any) => handleFieldChange(index, 'email', e.target.value)}
            inputType='text'
            inputValue={values?.email}
            isRequired={true}
            isDisabled={!Boolean(isEditable)}
            toolTipRequired={false}
          />

          <PhoneNumberInputField
            label={t('poc_phone_number')}
            errorStatus={errors?.phone?.status}
            errorMessage={errors?.phone?.message}
            handleChange={(e: any) => handleFieldChange(index, 'phone', e)}
            inputValue={values?.phone}
            isDisabled={!Boolean(isEditable)}
            isRequired={true}
            onlyCountries={['in']}
            id={`additional_poc_phone_${index}`}
          />
        </div>
      </div>
      {isDeleteConfirmOpen && (
        <ConfirmationDialog
          jobButton={'Delete'}
          cancelButton={'Cancel'}
          jobButtonColor='error'
          cancelButtonColor='secondary'
          confirmationText={'Are you sure you want to remove this contact?'}
          title={'Remove contact'}
          isOpen={isDeleteConfirmOpen}
          setIsConfirmationOpen={setIsDeleteConfirmOpen}
          handleJob={() => onDeleteAdditionalPOC(index)}
        />
      )}
    </>
  )
}

export default AdditionalPocContact
